<div class="product">
  <p class="product-name">
    {{ releaseCalendarProduct().name }}
  </p>
  <p>
    {{ formatBudgetValue(releaseCalendarProduct().total) }}
  </p>
  <div class="product-block">
    <p class="product-block-title">
      План
    </p>
    <p>
      Месяц: {{ formatBudgetValue(releaseCalendarProduct().plannedMonthPrice) }}
    </p>
    <p>
      День: {{ formatBudgetValue(releaseCalendarProduct().plannedDayPrice) }}
    </p>
  </div>
  <div class="product-block">
    <p class="product-block-title">
      Остаток
    </p>
    <p>
      {{ formatBudgetValue(releaseCalendarProduct().plannedMonthPrice - releaseCalendarProduct().total) }}
    </p>
  </div>
</div>
